<template>
  <div class="row mb-0 mb-md-5 mt-4" v-if="showButton">
    <div class="col-12" v-if="display('custom_checkboxes')">
      <div class="mb-3">
        <div class="form-check text-start" v-for="(item, index) in custom_checkboxes" :key="index">
          <input
            class="form-check-input"
            :class="{
              'is-invalid': 'custom_checkboxes' in errors && !customCheckboxesCheck[index],
            }"
            type="checkbox"
            value=""
            :id="`customCheck${index}`"
            v-model="customCheckboxesCheck[index]"
          />
          <label class="form-check-label small" v-html="snarkdown(item.text)" :for="`customCheck${index}`"></label>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="display('marketing_checkbox')">
      <div class="mb-3">
        <div class="form-check text-start">
          <input class="form-check-input" type="checkbox" value="" id="marketing-checkbox" v-model="marketing" />
          <label
            class="form-check-label small"
            v-html="snarkdown(marketing_checkbox_text)"
            for="marketing-checkbox"
          ></label>
        </div>
      </div>
    </div>
    <div class="col-12 text-muted mb-2" v-if="display('display_no_return_policy_info')">
      <small>
        {{
          'By clicking the button below to proceed you agree that you will be provided with immediate access to digital content as soon as you complete your purchase, without waiting the 14-day withdrawal period. Therefore, you expressly waive your right to withdraw from this purchase.'
            | translate
        }}
      </small>
    </div>
    <div class="col-12">
      <div class="text-muted">
        <div id="standard_agreement" class="mb-3 small" v-if="display('standard_agreement')">
          <span>
            {{ 'By completing this purchase, I agree to' | translate }}
            <a href="/terms" target="_blank">{{ 'Terms' | translate }}</a>

            {{ 'and' | translate }}
            <a href="/privacy" target="_blank">{{ 'Privacy Policy' | translate }}.</a>
          </span>
        </div>
        <div
          v-if="display_additional_legal_notes"
          id="additional_legal_notes"
          class="mb-3 small"
          v-html="additional_legal_notes"
        ></div>
      </div>

      <div class="d-grid">
        <button
          id="buy-btn"
          @click.prevent="submit"
          class="btn btn-dark p-2 hover-shadow p-0 overflow-hidden"
          style="font-weight: 600"
          :disabled="working"
        >
          <div class="shine"></div>
          <div class="float-end">
            <svg
              viewBox="0 0 24 24"
              width="20"
              height="20"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="css-i6dzq1"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </div>
          <span v-if="working" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-if="hasAccess">
            {{ 'Get access' | translate }}
          </span>
          <span v-else-if="isFree">
            {{ 'Get free access' | translate }}
          </span>
          <span v-else-if="checkoutType === 'single'">
            {{ 'Confirm and pay' | translate }}
          </span>
          <span v-else-if="checkoutType === 'membership'">
            {{ 'Subscribe' | translate }}
          </span>
        </button>
        <div class="toast-container position-fixed bottom-0 end-0 p-3">
          <div
            v-if="!isEmpty(errors)"
            class="toast align-items-center text-bg-warning border-0"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div class="d-flex">
              <div class="toast-body px-3">
                {{ 'Validation error' | translate }}
              </div>
              <button
                type="button"
                class="btn-close btn-close-dark me-3 m-auto"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3 small text-secondary" v-if="paymentProviderLogoSrc && !isFree">
        <div class="d-flex justify-content-center align-items-center">
          <div>{{ 'Transaction security is ensured by' | translate }}</div>
          <img class="img-fluid ms-3" :src="paymentProviderLogoSrc" :alt="paymentProvider" style="max-height: 22px" />
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="enrollment_disabled" class="d-grid">
    <button class="btn btn-primary" disabled>
      {{ 'Enrollment disabled' | translate }}
    </button>
  </div>
</template>

<script>
import _ from 'lodash'
import snarkdown from 'snarkdown'

const vatRegex =
  /^((AT)U[0-9]{8}|(BE)0[0-9]{9}|(BG)[0-9]{9,10}|(CY)[0-9]{8}L|(CZ)[0-9]{8,10}|(DE)[0-9]{9}|(DK)[0-9]{8}|(EE)[0-9]{9}|(EL|GR)[0-9]{9}|(ES)[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)[0-9]{8}|(FR)[0-9A-Z]{2}[0-9]{9}|(GB)([0-9]{9}([0-9]{3})|[A-Z]{2}[0-9]{3})|(HU)[0-9]{8}|(IE)[0-9]S[0-9]{5}L|(IT)[0-9]{11}|(LT)([0-9]{9}|[0-9]{12})|(LU)[0-9]{8}|(LV)[0-9]{11}|(MT)[0-9]{8}|(NL)[0-9]{9}B[0-9]{2}|(PL)[0-9]{10}|(PT)[0-9]{9}|(RO)[0-9]{2,10}|(SE)[0-9]{12}|(SI)[0-9]{8}|(SK)[0-9]{10}|[0-9]{9}(MVA)|[0-9]{9}|[0-9]{10}|[0-9]{11}|[0-9]{12})$/

export default {
  data() {
    return {
      working: false,
      customCheckboxesCheck: [],
      marketing: null,
      stripe: null,
      errors: {},
      payuToken: null,
      fbEventSent: false,
      gaEventSent: false,
      gtagEventSent: false,
    }
  },
  mounted() {
    this.viewCheckoutEvent()
  },
  methods: {
    viewCheckoutEvent() {
      window.dataLayer.push({
        event: 'view_checkout',
        items: [
          {
            item_id: _.get(this.googleTagEventData, 'items[0].item_id'),
            item_name: _.get(this.googleTagEventData, 'items[0].item_name'),
          },
        ],
      })
    },
    showToasts() {
      setTimeout(() => {
        document.querySelectorAll('.toast').forEach((toast) => {
          new bootstrap.Toast(toast).show()
        })
      }, 500)
    },
    isEmpty(o) {
      return _.isEmpty(o)
    },
    snarkdown(text) {
      if (!text) {
        return ''
      }
      return snarkdown(text)
    },
    payuTokenize() {
      return window.payu
        .tokenize('MULTI')
        .then((result) => {
          result.status === 'SUCCESS'
            ? (this.payuToken = result.body.token)
            : (this.errors = { cypher: result.error.messages })
        })
        .catch((error) => {
          this.errors = { cypher: ['Required'] }
        })
    },
    display(element) {
      if (
        element === 'marketing_checkbox' &&
        this.display_marketing_checkbox &&
        !this.student.allow_instructor_emails
      ) {
        return true
      }

      if (element === 'standard_agreement' && !this.display_custom_checkboxes) {
        return true
      }

      if (element === 'custom_checkboxes' && this.display_custom_checkboxes) {
        return true
      }

      if (element === 'display_no_return_policy_info' && this.display_no_return_policy_info) {
        return true
      }

      return false
    },
    validateCustomCheckboxes() {
      if (this.custom_checkboxes) {
        let checked = this.custom_checkboxes.map((item, index) => {
          return this.customCheckboxesCheck[index]
        })
        if (_.every(checked)) {
          return false
        } else {
          return [this.$t('All checkboxes are required')]
        }
      }
      return false
    },
    validateCompanyName() {
      if (this.student.company_name.length < 2) {
        return [this.$t('This field is required')]
      }
      return false
    },
    validateCountry() {
      if (!this.student.country) {
        return [this.$t('This field is required')]
      }
      return false
    },
    validateVatNumber() {
      if (this.student.vat_number) {
        if (!this.student.vat_number.match(vatRegex)) {
          return [this.$t('Only letters and numbers. Example: PL1234567890')]
        }
      }
      return false
    },
    validate() {
      const es = {}
      const hello = {}

      if (this.display_custom_checkboxes) {
        const customCheckboxes = this.validateCustomCheckboxes()
        if (customCheckboxes) {
          es.custom_checkboxes = customCheckboxes
        }
      }

      const vatNumber = this.validateVatNumber()

      if (vatNumber) {
        es.vat_number = vatNumber
      }

      this.errors = es
      this.$store.commit('updateErrors', es)

      return es
    },
    facebookCheckoutEvent() {
      if (typeof fbq === 'undefined' || this.fbEventSent) {
        return null
      }

      fbq('track', 'InitiateCheckout')
      this.fbEventSent = true
    },

    googleCheckoutEvent() {
      if (typeof gtag_send_to !== 'undefined') {
        this.googleTagEventData.send_to = gtag_send_to
      }

      dataLayer.push({
        event: 'begin_checkout',
        ecommerce: _.cloneDeep(this.googleTagEventData),
      })

      // if (typeof ga !== 'undefined' && !this.gaEventSent) {
      //   ga('event', 'begin_checkout', this.googleTagEventData)
      // this.gaEventSent = true
      // }

      // if (typeof gtag !== 'undefined' && !this.gtagEventSent) {
      //   gtag('event', 'begin_checkout', this.googleTagEventData)
      // this.gtagEventSent = true
      // }
    },

    submit() {
      this.working = true
      const es = this.validate()

      if (!_.isEmpty(es)) {
        this.showToasts()
        this.stopWorking()
        return false
      }

      this.errors = {}

      this.$store.commit('updateErrors', {})

      this.facebookCheckoutEvent()
      this.googleCheckoutEvent()

      if (this.checkoutType === 'single') {
        if (this.student.email) {
          this.checkout()
        } else if (!this.student.email) {
          this.register()
        }
      } else if (this.checkoutType === 'membership' && this.paymentProvider === 'Tpay') {
        if (this.student.email) {
          this.subscriptionCheckout()
        } else if (!this.student.email) {
          this.subscriptionCheckoutRegister()
        }
      } else if (this.checkoutType === 'membership' && this.paymentProvider === 'Stripe') {
        if (this.student.email) {
          this.subscriptionCheckoutStripe()
        } else if (!this.student.email) {
          this.subscriptionCheckoutRegister()
        }
      } else if (this.checkoutType === 'membership' && this.paymentProvider === 'PayU') {
        if (this.student.email) {
          this.subscriptionCheckoutPayu()
        } else if (!this.student.email) {
          this.subscriptionCheckoutRegister()
        }
      }
    },
    subscriptionCheckoutPayu() {
      this.payuTokenize()
        .then(() => {
          return this.$api.onePageCheckoutSubscription({
            ...this.student,
            cypher: this.payuToken,
            plan: this.plan.name,
            mo: this.mo.id,
            marketing: this.marketing,
          })
        })
        .then(({ data }) => {
          if (data.redirect && _.includes(['success', '3ds'], data.type)) {
            window.location.href = data.redirect
          }
          this.stopWorking()
        })
        .catch((errors) => {
          this.errors = _.get(errors, 'response.data.errors', {})
          // this.errors = { card: ['Card error'] }
          this.$store.commit('updateErrors', this.errors)
          this.stopWorking()
          this.showToasts()
        })
    },
    getCookie(name) {
      const cookies = Object.fromEntries(
        document.cookie.split('; ').map((cookieStr) => {
          const [key, ...val] = cookieStr.split('=')
          return [key, val.join('=')]
        }),
      )
      if (name in cookies) {
        try {
          return decodeURIComponent(cookies[name])
        } catch (e) {
          return cookies[name]
        }
      }
      return null
    },
    subscriptionCheckout() {
      if (!this.$store.dispatch('regenerateCypher')) {
        this.$store.commit('updateErrors', {
          cypher: [this.$t('Please check your card details.')],
        })
        return
      }

      this.$api
        .onePageCheckoutSubscription({
          ...this.student,
          cypher: this.cypher,
          plan: this.plan.name,
          mo: this.mo.id,
          marketing: this.marketing,
          meta: this.getFacebookMeta(),
        })
        .then(({ data }) => {
          if (data.redirect && _.includes(['success', '3ds'], data.type)) {
            window.location.href = data.redirect
          }
          this.stopWorking()
        })
        .catch((errors) => {
          this.stopWorking()
          let es = _.get(errors, 'response.data.errors', {})
          this.$store.commit('updateErrors', es, {})
          this.showToasts()
        })
    },
    subscriptionCheckoutRegister() {
      this.$api
        .onePageCheckoutSubscriptionRegister({
          ...this.registrationData,
          ...this.student,
          marketing: this.marketing,
          meta: this.getFacebookMeta(),
        })
        .then(({ data }) => {
          this.$store.commit('updateUser', data)
          return data
        })
        .then((user) => {
          if (this.paymentProvider === 'Tpay') {
            this.subscriptionCheckout()
          } else if (this.paymentProvider === 'Stripe') {
            this.subscriptionCheckoutStripe()
          } else if (this.paymentProvider === 'PayU') {
            this.subscriptionCheckoutPayu()
          }
        })
        .catch((errors) => {
          this.stopWorking()
          let es = _.get(errors, 'response.data.errors', {})
          this.$store.commit('updateErrors', es, {})
        })
    },
    subscriptionCheckoutStripe() {
      this.$api
        .onePageCheckoutSubscriptionStripe({
          ...this.student,
          plan: this.plan.name,
          mo: this.mo.id,
          marketing: this.marketing,
          meta: this.getFacebookMeta(),
        })
        .then(({ data }) => {
          if (data.redirect && _.includes(['success', '3ds'], data.type)) {
            window.location.href = data.redirect
          }
          this.stopWorking()
        })
        .catch((errors) => {
          this.stopWorking()
          let es = _.get(errors, 'response.data.errors', {})
          this.$store.commit('updateErrors', es, {})
          this.showToasts()
        })
    },
    createAndPost(path, params, method = 'post') {
      const form = document.createElement('form')
      form.method = method
      form.action = path

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input')
          hiddenField.type = 'hidden'
          hiddenField.name = key
          hiddenField.value = params[key]

          form.appendChild(hiddenField)
        }
      }

      document.body.appendChild(form)
      form.submit()
    },

    getFacebookMeta() {
      const fbRegex = /^[\w.-]+$/;

      let cookies = {
        fbc: this.getCookie('_fbc'),
        fbp: this.getCookie('_fbp'),
      };

      let meta = {};
      if (cookies.fbc && fbRegex.test(cookies.fbc)) {
        meta.fbc = cookies.fbc;
      }
      if (cookies.fbp && fbRegex.test(cookies.fbp)) {
        meta.fbp = cookies.fbp;
      }

      return Object.keys(meta).length ? meta : null;
    },
    redirectToPayment(data) {
      if (data.redirect) {
        return (window.location.href = data.redirect)
      } else if (data.payment_provider === 'Stripe') {
        this.stripe = Stripe(this.publishableApiKey)
        return this.stripe.redirectToCheckout({ sessionId: data.id })
      }

      const params = _.get(data, 'response.params')
      const url = _.get(data, 'response.url')

      if (url && params) {
        return this.createAndPost(url, params)
      }

      throw `Payment processing Error: ${data.payment_provider} - no url or params provided`
      this.stopWorking()
    },
    checkout() {
      this.$api
        .onePageCheckout(this.course.slug, {
          ...this.student,
          quantity: this.$store.state.quantity,
          price_variant: this.$store.getters.priceVariant,
          student_suggested_price: this.$store.getters.studentSuggestedPrice,
          selected_order_bumps: this.selectedOrderBumps,
          marketing: this.marketing,
          selected_slot: this.selectedSlot,
          shipping_data: this.processShippingData(),
          meta: this.getFacebookMeta(),
        })
        .then(({ data }) => {
          return this.redirectToPayment(data)
        })
        .catch((error) => {
          this.stopWorking()
          const validationErrors = _.get(error, 'response.data.errors', {})
          if (validationErrors) {
            this.errors = validationErrors
            this.$store.commit('updateErrors', validationErrors)
            this.showToasts()
          } else {
            console.error(error)
          }
        })
    },
    register() {
      this.$api
        .onePageCheckoutRegister(this.course.slug, {
          ...this.registrationData,
          ...this.student,
          quantity: this.$store.state.quantity,
          price_variant: this.$store.getters.priceVariant,
          student_suggested_price: this.$store.getters.studentSuggestedPrice,
          selected_order_bumps: this.selectedOrderBumps,
          marketing: this.marketing,
          selected_slot: this.selectedSlot,
          shipping_data: this.processShippingData(),
          meta: this.getFacebookMeta(),
        })
        .then(({ data }) => {
          return this.redirectToPayment(data)
        })
        .then(this.stopWorking)
        .catch((error) => {
          this.stopWorking()
          const validationErrors = _.get(error, 'response.data.errors', {})
          if (validationErrors) {
            this.errors = validationErrors
            this.$store.commit('updateErrors', validationErrors)
            this.showToasts()
          } else {
            console.error(error)
          }
        })
    },
    stopWorking() {
      setTimeout(() => {
        this.working = false
      }, 2000)
    },

    processShippingData() {
      const productType = _.get(this.course, 'type')
      const shipmentType = _.get(this.shippingData, 'shipmentType')
      const differentShippingAddress = _.get(this.shippingData, 'differentShippingAddress')
      const notes = _.get(this.shippingData, 'notes')

      let data = {}

      if (productType === 'physical' && shipmentType === 'courier') {
        data = {
          shipmentType,
          differentShippingAddress,
          notes,
        }

        if (differentShippingAddress) {
          data.firstName = _.get(this.shippingData, 'firstName')
          data.lastName = _.get(this.shippingData, 'lastName')
          data.address = _.get(this.shippingData, 'address')
          data.city = _.get(this.shippingData, 'city')
          data.postalCode = _.get(this.shippingData, 'postalCode')
          data.phoneNumber = _.get(this.shippingData, 'phoneNumber')
        } else {
          data.firstName = _.get(this.student, 'name')
          data.lastName = _.get(this.student, 'last_name')
          data.address = _.get(this.student, 'address1')
          data.city = _.get(this.student, 'city')
          data.postalCode = _.get(this.student, 'postal_code')
          data.phoneNumber = _.get(this.student, 'phone')
        }
        return data
      } else if (productType === 'physical' && shipmentType === 'parcel_locker') {
        data = {
          shipmentType,
          notes,
          differentShippingAddress: false,
          parcelLockerCode: _.get(this.shippingData, 'parcelLockerCode'),
          firstName: _.get(this.student, 'name') || _.get(this.registrationData, 'name'),
          lastName: _.get(this.student, 'last_name') || _.get(this.registrationData, 'last_name'),
          address: _.get(this.student, 'address1'),
          city: _.get(this.student, 'city'),
          postalCode: _.get(this.student, 'postal_code'),
          phoneNumber: _.get(this.student, 'phone'),
        }

        return data
      }

      return null
    },
  },
  computed: {
    selectedSlot() {
      return this.$store.state.selectedSlot
    },
    shippingData() {
      return this.$store.state.shippingData
    },
    promoCode() {
      return this.$store.state.promoCode
    },
    googleTagEventData() {
      // one-time example
      // let one_time_example = {
      //   currency: 'PLN',
      //   value: 99.24,
      //   items: [
      //     { item_id: 'sub_3_monthly', item_name: 'One1', item_variant: 'monthly', item_category: 'subscription' },
      //   ],
      // }

      // subscription example
      // let subscription_example = {
      //   currency: 'PLN',
      //   value: 99.24,
      //   items: [
      //     { item_id: 'sub_3_monthly', item_name: 'One1', item_variant: 'monthly', item_category: 'subscription' },
      //   ],
      // }

      let rawPrice = (this.price === null || this.price === undefined) ? 0 : this.price;
      let p = Number(parseFloat(rawPrice / 100).toFixed(2));

      let data = {
        currency: this.page.currency,
        value: p,
      }
      let coupon = _.get(this, 'promoCode.code', null)

      if (this.checkoutType === 'membership') {
        data.items = [
          {
            item_id: `sub_${this.mo.id}`,
            item_name: `${this.mo.header}`,
            item_variant: this.plan.title,
            item_category: 'subscription',
            quantity: 1,
            price: p,
          },
        ]
      } else {
        data.items = [
          {
            item_id: _.get(this.course, 'id', null),
            item_name: _.get(this.course, 'slug', null),
            item_category: 'one-time',
            quantity: 1,
            price: p,
          },
        ]
      }

      if (coupon) {
        data.coupon = coupon
      }

      return data
    },
    hasAccess() {
      return this.$store.state.hasAccess
    },
    publishableApiKey() {
      return this.$store.state.publishableApiKey
    },
    selectedOrderBumps() {
      return this.$store.state.selectedOrderBumps.map((ob) => ob.id)
    },
    validationErrorsExist() {
      return _.isEmpty(this.errors)
    },
    page() {
      return this.$store.state.page
    },
    paymentProvider() {
      return _.get(this, 'page.payment_provider')
    },
    paymentProviderLogoSrc() {
      const base = 'https://djceg34j53tq.cloudfront.net/integrations/logos/'
      const logos = {
        Przelewy24: 'przelewy_24.svg',
        Paynow: 'paynow.png',
        Stripe: 'stripe.svg',
        Bluemedia: 'autopay.svg',
        PayU: 'payu.png',
        PayPal: 'pp.png',
        Tpay: 'tpay.png',
        Dotpay: 'dotpay.png',
        Braintree: 'braintree.png',
        Imoje: 'imoje.svg',
        Netgiro: 'netgiro.svg',
      }
      const logo = logos[this.paymentProvider] || null

      if (!logo) return null

      return `${base}${logo}`
    },
    display_additional_legal_notes() {
      return _.get(this.$store.state, 'page.options.display_additional_legal_notes')
    },
    additional_legal_notes() {
      return this.snarkdown(_.get(this.$store.state, 'page.options.additional_legal_notes'))
    },
    display_no_return_policy_info() {
      return _.get(this.$store.state, 'page.options.display_no_return_policy_info')
    },
    custom_checkboxes() {
      return _.get(this.$store.state, 'page.options.custom_checkout_checkboxes')
    },
    display_marketing_checkbox() {
      return _.get(this.$store.state, 'page.options.display_marketing_checkbox')
    },
    marketing_checkbox_text() {
      let text = _.get(this.$store.state, 'page.options.marketing_checkbox_text')

      if (_.isNil(text)) {
        return this.$t(
          'I agree to receive the email newsletter, including information about new products, promotions, and services.',
        )
      }
      return text
    },
    display_custom_checkboxes() {
      return _.get(this.$store.state, 'page.options.display_custom_checkout_checkboxes')
    },
    price() {
      return _.get(this.course, 'finalPrice', null) || _.get(this.plan, 'price', 0)
    },
    isFree() {
      return _.get(this.course, 'finalPrice') === 0 || _.get(this.plan, 'price') === 0
    },
    course() {
      return this.$store.getters.courseAfterPriceReductions
    },
    cypher() {
      return this.$store.state.cypher
    },
    plan() {
      return this.$store.getters.currentPlan
    },
    mo() {
      return this.$store.getters.currentMo
    },
    checkoutType() {
      return this.$store.state.checkoutType
    },
    registrationData() {
      return this.$store.state.registrationData
    },
    course() {
      return this.$store.getters.courseAfterPriceReductions
    },
    // showRegisterInfo() {
    //   if (this.student.email) {
    //     return false
    //   }
    //   return true
    // },
    enrollment_disabled() {
      return _.get(this, 'course.enrollment_disabled', false)
    },
    showButton() {
      if (_.get(this, 'course.enrollment_disabled', false)) {
        return false
      }
      let view = this.$store.state.view
      if (this.student.email) {
        return true
      }
      if (view === 'register') {
        return true
      }
      if (view === 'login') {
        return false
      }
      return false
    },
    student() {
      return this.$store.state.user
    },
  },
}

/* example error
{
  "email":["Podaj poprawny adres e-mail."],
  "password":["The password must be at least 6 characters.","The password confirmation does not match."]
}
*/
</script>

<style lang="scss">
.hover-shadow {
  position: relative;
  display: inline-block;
  -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.hover-shadow::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 0;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.hover-shadow:hover {
  -webkit-transform: translateY(-0.2em);
  transform: translateY(-0.2em);
}

.hover-shadow:hover::after {
  opacity: 1;
}

.shine:after {
  content: '';
  top: 0;
  transform: translateX(100%);
  width: 100%;
  height: 46px;
  position: absolute;
  z-index: 0;
  animation: slide 3s infinite 5s;
  transition: opacity 0.2s ease;

  /* 
  CSS Gradient - complete browser support from http://www.colorzilla.com/gradient-editor/ 
  */
  background: linear-gradient(
    to right,
    rgba(52, 49, 69, 0) 0%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(52, 49, 69, 0) 100%
  ); /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#007db9e8',GradientType=1 ); /* IE6-9 */
}

/* animation */

@keyframes slide {
  0% {
    transform: translateX(-800px);
  }
  100% {
    transform: translateX(800px);
  }
}
</style>
